var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0738 2.03982L6.43978 0.503906L1.80578 2.03982C1.45664 2.15557 1.15284 2.37838 0.937546 2.67661C0.722249 2.97484 0.606397 3.33333 0.606445 3.70116V7.49866C0.606445 11.8877 5.97311 14.3114 6.20295 14.4123L6.40945 14.5039L6.62411 14.4327C6.85511 14.3557 12.2731 12.5019 12.2731 7.49866V3.70116C12.2732 3.33333 12.1573 2.97484 11.942 2.67661C11.7267 2.37838 11.4229 2.15557 11.0738 2.03982ZM6.69878 8.65891C6.5968 8.76157 6.47545 8.84294 6.34176 8.89832C6.20808 8.9537 6.06473 8.98197 5.92003 8.98149H5.90078C5.75313 8.97923 5.60748 8.94705 5.47262 8.88689C5.33777 8.82673 5.21651 8.73985 5.1162 8.63149L3.77103 7.23149L4.61278 6.42532L5.92178 7.79032L8.94403 4.76807L9.76886 5.59291L6.69878 8.65891Z",
    fill: "url(#paint0_linear_3113_19695)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3113_19695",
    x1: 6.43978,
    y1: 0.503906,
    x2: 6.43978,
    y2: 14.5039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E6930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D8C40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.7cfade1d83d9460918246a8e9c7db8f5.svg";
export { ForwardRef as ReactComponent };